import { loginRequest } from 'auth/config/authConfig';
import { msalInstance } from 'auth/userAccount';
import axios from 'axios';

export async function jobProjectionsLoader({ params }) {
  const jobId = params.jobId;

  const account = msalInstance.getAllAccounts()[0];
  const msalResponse = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: account,
  });
  const token = msalResponse.accessToken;

  const jobMainInfo = (
    await axios.get(`jobs/${jobId}/mainInfo`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
  ).data;

  return { job: jobMainInfo };
}
